<template>
    <div class="main-content">
        <!-- Header -->
        <div
            class="header pb-5 pt-5 pt-lg-5 d-flex align-items-center"
            style="
                background-size: cover;
                background-position: center top;
            "
        >
            <!-- Mask -->
            <span class="mask bg-gradient-default opacity-9"></span>
            <!-- Header container -->
            <div class="container-fluid d-flex align-items-center">
                <div class="row w-100">
                    <div class="col-lg-6 col-md-10">
                        <h1 class="display-4 text-white text-center">Olá {{ user.displayName.split(' ')[0] }}</h1>
                        <p class="text-white mt-0 mb-5 text-center">
                            Este é sua página de perfil. Aqui você pode alterar suas informações<!--  e alterar sua foto de perfil. -->
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!-- Page content -->
        <div class="container-fluid mt--5">
            <div class="row">
                <!-- Card Profile -->
                <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">
                    <div class="card card-profile shadow">
                        <div class="row justify-content-center">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                    <img
                                        v-if="user"
                                        :src="user.photoURL || 'https://ui-avatars.com/api/?name=' + user.displayName + '&rounded=true&background=e65862&color=ffffff'"
                                        alt
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="card-header text-center border-0 pt-6 pt-md-4 pb-0 pb-md-5" > </div>
                        <div class="card-body pt-0 pt-md-4">
                            <div class="row">
                                <!-- <div class="col">
                                    <div
                                        class="card-profile-stats d-flex justify-content-center mt-md-5"
                                    >
                                        <div>
                                            <span class="heading">22</span>
                                            <span class="description"
                                                >Pesquisas</span
                                            >
                                        </div>
                                        <div>
                                            <span class="heading">10</span>
                                            <span class="description"
                                                >Feedbacks</span
                                            >
                                        </div>
                                        <div>
                                            <span class="heading">89</span>
                                            <span class="description"
                                                >Sugestões</span
                                            >
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                            <div class="text-center pt-3">
                                <h3>
                                    {{ user.displayName }}
                                    <!-- <span class="font-weight-light" v-if="age">
                                        {{ age }}
                                    </span> -->
                                </h3>
                                <!-- <div class="h5 mt-4">
                                    <i class="ni business_briefcase-24 mr-2"></i>
                                    {{ user.occupation || 'Cargo' }}
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Main Card -->
                <div class="col-xl-8 order-xl-1">
                    <card-loader v-if="loading" height="320px" />
                    <div v-else class="card bg-secondary shadow border-0">
                        <div class="card-header bg-white">
                            <div class="row align-items-center">
                                <div class="col-12 text-center">
                                    <h3 class="mb-0">Meu Perfil</h3>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <form>
                                <h6 class="heading-small text-muted mb-4 text-center">
                                    Informações Pessoais
                                </h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <b-form-group
                                                id="input-group-name"
                                                label="Nome:"
                                                label-for="input-name"
                                            >
                                                <b-form-input
                                                    v-model="form.displayName"
                                                    id="input-name"
                                                    required
                                                    placeholder="Digite seu nome"
                                                />
                                            </b-form-group>
                                        </div>
                                        <div class="col-lg-6">
                                            <b-form-group
                                                id="input-group-email"
                                                label="E-mail:"
                                                label-for="input-email"
                                            >
                                                <b-form-input
                                                    v-model="form.email"
                                                    id="input-email"
                                                    required
                                                    placeholder="email@exemplo.com"
                                                />
                                            </b-form-group>
                                        </div>
                                        <!-- Gender -->
                                        <div class="col-lg-6">
                                            <b-form-group
                                                id="input-group-genders"
                                                label="Gênero"
                                                label-for="input-genders"
                                            >
                                                <b-form-select
                                                    id="input-genders"
                                                    v-model="form.gender"
                                                    :options="genders"
                                                />
                                            </b-form-group>
                                        </div>
                                        <!-- Birth Date -->
                                        <div class="col-lg-6">
                                            <b-form-group
                                                id="input-group-birth-date"
                                                label="Data de Nascimento"
                                                label-for="input-birth-date"
                                            >
                                                <b-form-input
                                                    v-model="form.birthDate"
                                                    id="input-birth-date"
                                                    required
                                                    :placeholder="today"
                                                    v-mask="'##/##/####'"
                                                />
                                            </b-form-group>
                                        </div>
                                    </div>
                                </div>
                                <!-- <hr class="my-4" /> -->
                                <!-- Professional Info -->
                                <!-- <h6 class="heading-small text-muted mb-4 text-center">
                                    Informações Profissionais
                                </h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <b-form-group
                                                id="input-group-sectors"
                                                label="Setor"
                                                label-for="input-sectors"
                                            >
                                                <b-form-tags
                                                    input-id="input-sectors"
                                                    v-model="sectors"
                                                    placeholder="Adicione um setor.."
                                                />
                                            </b-form-group>
                                        </div>
                                        <div class="col-lg-6">
                                            <b-form-group
                                                id="input-group-roles"
                                                label="Cargo"
                                                label-for="input-roles"
                                            >
                                                <b-form-select
                                                    id="input-roles"
                                                    v-model="role"
                                                    :options="roles"
                                                />
                                            </b-form-group>
                                        </div>
                                    </div>
                                </div> -->

                                <!-- <hr class="my-4" /> -->

                                <div class="d-flex mt-3 pl-lg-4">
                                    <b-btn
                                        variant="primary"
                                        class="btn"
                                        @click="save"
                                    >
                                        Salvar
                                    </b-btn>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api/api'
import auth from '@/firebase/auth'

// Inspiration: https://www.creative-tim.com/bits/bootstrap/user-profile-page-argon-dashboard
export default {
    name: 'Profile',
    data () {
        return {
            form: {
                displayName: '',
                email: '',
                birthDate: '',
                gender: '',
            },
            genders: [
                { value: '', text: '' },
                { value: 'male', text: 'Masculino' },
                { value: 'female', text: 'Feminino' },
            ],
            loading: true,
        }
    },
    components: {
        CardLoader: () => import('@/components/Loaders/CardLoader'),
    },
    computed: {
        user () {
            return this.$store.getters['auth/user']
        },
    },
    methods: {
        save () {
            this.$store
                .dispatch('auth/editUser', {
                    form: this.form,
                    uid: this.user.uid,
                })
                .then(() => {
                    this.$store.dispatch('auth/editCurrentUser', this.form)
                })
                .then((response) => {
                    this.$bvToast.toast('Dados de perfil salvos.', {
                        title: 'Salvo!',
                        variant: 'success',
                        solid: true,
                    })
                })
                .catch(() => {
                    this.$bvToast.toast('Erro ao salvar os dados do perfil.', {
                        title: 'Ops!',
                        variant: 'danger',
                        solid: true,
                    })
                })
        },
        getUserData () {
            auth
                .currentUser
                .getIdToken()
                .then((token) => {
                    api
                        .get(`/auth/user/${this.user.uid}`, {
                            headers: {
                                token,
                            },
                        })
                        .then(response => {
                            this.form = {
                                ...this.form,
                                ...response.data.user,
                            }

                            this.loading = false
                        })
                })
                .catch(err => console.log(err))
        },
    },
    beforeMount () {
        const date = new Date()
        this.today = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`
    },
    created () {
        this.getUserData()
    },
}
</script>

<style lang="scss" scoped>
.bg-secondary {
  background-color: #f7fafc !important;
}

.mt--5 {
  margin-top: -5rem !important;
}

.pt-6 {
  padding-top: 6rem !important;
}

.pb-8 {
  padding-bottom: 8rem !important;
}

.bg-gradient-default {
  background: linear-gradient(87deg, #172b4d 0, #1a174d 100%) !important;
}

@keyframes floating-lg {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(15px);
  }

  100% {
    transform: translateY(0px);
  }
}

@keyframes floating {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(10px);
  }

  100% {
    transform: translateY(0px);
  }
}

@keyframes floating-sm {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(5px);
  }

  100% {
    transform: translateY(0px);
  }
}

.opacity-9 {
  opacity: .9 !important;
}

.card-profile-image {
  position: relative;
}

.card-profile-image img {
  position: absolute;
  left: 50%;
  max-width: 96px;
  height: 96px;
  transition: all .15s ease;
  transform: translate(-50%, -30%);
  border-radius: .375rem;
}

.card-profile-image img:hover {
  transform: translate(-50%, -33%);
}

.card-profile-stats {
  padding: 1rem 0;
}

.card-profile-stats>div {
  margin-right: 1rem;
  padding: .875rem;
  text-align: center;
}

.card-profile-stats>div:last-child {
  margin-right: 0;
}

.card-profile-stats>div .heading {
  font-size: 1.1rem;
  font-weight: bold;
  display: block;
}

.card-profile-stats>div .description {
  font-size: .875rem;
  color: #adb5bd;
}

@media (min-width(var(--breakpoint-sm))) {
  .main-content .container-fluid {
    padding-right: 39px !important;
    padding-left: 39px !important;
  }
}

.header {
  position: relative;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all .15s ease;
}

@media screen and (prefers-reduced-motion: reduce) {
  .mask {
    transition: none;
  }
}
</style>
